import BasePasteSpecial from './paste-base-strategy';
import { IPasteSpecialServiceDelegates, IPasteSpecialStrategy } from './interface';
import { CopyElementType, ICopiedSdkData, ICopyInfo } from '@src/slide/domain/ui-model/element-modeles/property/copy/copy-model/paste-special.interface';
import { ICTTextParagraph, IEGTextRun, IShapeData } from '@tencent/slide-sdk-model';

// 粘贴为文本，可扩展
export default class PasteText extends BasePasteSpecial implements IPasteSpecialStrategy {
    public constructor(copyInfo: ICopyInfo, serviceDelegates: IPasteSpecialServiceDelegates) {
        super(copyInfo, serviceDelegates);
    }
    public paste() {
        if (this.type !== CopyElementType.TEXT) {
            return;
        }
        this.textSelectivePasteState?.beforePaste();
        // 先执行undo操作，上次粘贴逻辑
        this.undoRedoService?.undo();
        this.pasteText();
    }

    private pasteText() {
        const { ownSdkData } = this.clipboardData.data[0] as ICopiedSdkData<IShapeData>;
        const pureTextData = {
            ...ownSdkData,
            txBody: {
                p: ownSdkData.txBody?.p?.map((d: ICTTextParagraph) => ({
                    egTextRun: d.egTextRun?.map(removeTextrunStyle),
                })),
            },
        };
        // 需要等待撤回之后光标更新到正确位置再执行新的粘贴策略
        const off = this.textSelectionUndoRedo?.afterUndoRedo(() => {
            this.copyPasteManager?.dangerousInstance?.runTextSelectivePaste(pureTextData, false);
            off?.();
            this.textSelectivePasteState?.afterPaste();
        });
    }
}

/**
 * 移除 textrun 上的样式
 * @param textrun
 * @returns
 */
function removeTextrunStyle(textrun: IEGTextRun) {
    if (textrun.br) {
        return textrun;
    }
    if (textrun.fld) {
        return {
            fld: {
                t: textrun.fld?.t,
            },
        };
    }
    return {
        r: {
            t: textrun.r?.t,
        },
    };
}
